import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { informationToAction } from '../../data/home';
import { easeOutStrong, fadeUp } from '../../utils/motion';

/** "From information to action": one illustrative workflow from request to progress review. */
export function HomeActionExamples() {
  return <section aria-labelledby="action-title" className="bg-navy text-white py-20 lg:py-28" data-id="element-1082" data-mp="1auim28h9os7q">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1083" data-mp="1ou1vr5pq8bm5">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-14" data-id="element-1084" data-mp="1kuj6xyusbge1">
          <div className="lg:col-span-5" data-id="element-1085" data-mp="1ylo1wnn7jki1">
            <p className="text-sm font-medium text-teal mb-3" data-id="element-1086" data-mp="1ykmoicipylx5">Illustrative workflow</p>
            <h2 id="action-title" className="font-heading font-bold text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-1087" data-mp="1tmv03sha9hxp">
              From information to action
            </h2>
          </div>
          <p className="lg:col-span-7 lg:pt-9 text-xl text-white/80 leading-relaxed" data-id="element-1088" data-mp="23lsh8acdq96o">
            Follow one request from arrival through coordinated support to learning what helped.
          </p>
        </motion.div>

        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/15 border border-white/15 rounded-lg overflow-hidden" data-id="element-1089" data-mp="3rkovwqrglspq">
          {informationToAction.map((item, index) => <motion.li key={item.step} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.25,
          delay: Math.min(index * 0.04, 0.24),
          ease: easeOutStrong
        }} className="bg-navy p-6 lg:p-8" data-id="element-1090" data-mp="4h0o8zyrqkxp" data-mpi={index}>
              <h3 className="flex items-center gap-3 font-heading font-bold text-xl leading-snug" data-id="element-1091" data-mp="n55lrpou19o2">
                <span aria-hidden="true" className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-teal/60 text-sm font-semibold text-teal" data-id="element-1092" data-mp="s6crzkbbu0sm">
                  {index + 1}
                </span>
                {item.step}
              </h3>
              <p className="mt-3 text-white/75 leading-relaxed" data-id="element-1093" data-mp="2oa9em9o4gcse">{item.body}</p>
            </motion.li>)}
        </ol>

        <motion.a {...fadeUp} href="/government" className="mt-10 inline-flex items-center gap-2 font-semibold text-white hover:text-teal transition-colors duration-150 sm:whitespace-nowrap" data-id="element-1094" data-mp="2y6m9vbzbeyp9">
          Explore this workflow in the Government solution <ArrowRight size={16} aria-hidden="true" data-id="element-1095" data-mp="37yi6eilr6grd" />
        </motion.a>
      </div>
    </section>;
}